import { ILoginAvailableUseCase } from "../../../presentation/useCases/read/login_available_use_case";
import { IAuthRepository } from "../../repositories/auth_repository";

/**
 * LoginAvailableUseCase
 */

export class LoginAvailableUseCase implements ILoginAvailableUseCase {
  constructor(
    private readonly repository: IAuthRepository,
  ) { }

  loginAvailable(login: string, empresaId: number): Promise<boolean> {
    return this.repository.loginAvailable(login, empresaId);
  }
}